import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
//import { CalendarModule } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { CardModule } from 'primeng/card';
//import { ChipsModule } from 'primeng/chips';
//import { DropdownModule } from 'primeng/dropdown';
//import { SelectModule } from 'primeng/select';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
//import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
// import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PickListModule } from 'primeng/picklist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
//import { TabViewModule } from 'primeng/tabview';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AppBarMenuComponent } from './components/app-bar-menu/app-bar-menu.component';
import { AppButtonSetComponent } from './components/app-button-set/app-button-set.component';
import { PanelMenuComponent } from './components/app-panel-menu/panel-menu.component';
import { AppStatusComponent } from './components/app-status/app-status.component';
import { AppButtonComponent } from './components/app-button/app-button.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SkeletonModule } from 'primeng/skeleton';
import {CarouselModule } from 'primeng/carousel';
import { SelectModule } from 'primeng/select';
import { AppBannerComponent } from './components/app-banner/app-banner.component';


@NgModule({
  declarations: [
    AppBarMenuComponent,
    AppButtonSetComponent,
    AppStatusComponent,
    PanelMenuComponent,
    AppButtonComponent,
    AppBannerComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    TableModule,
    DynamicDialogModule,
    PanelModule,
    SelectModule,
    // InputTextareaModule,
    InputTextModule,
    ProgressSpinnerModule,
    ToastModule,
    TooltipModule,
    //CalendarModule,
    DatePickerModule,
    FormsModule,
    MultiSelectModule,
    //TabViewModule,
    TabsModule,
    CardModule,
    //InputSwitchModule,
    ToggleSwitchModule,
    PickListModule,
    BadgeModule,
    AccordionModule,
  //  ChipsModule,
    PanelMenuModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    AppBarMenuComponent,
    AppButtonSetComponent,
    AppStatusComponent,
    PanelMenuComponent,
    AppButtonComponent,
    AppBannerComponent,
    ButtonModule,
    TableModule,
    DynamicDialogModule,
    PanelModule,
    //DropdownModule,
    // InputTextareaModule,
    InputTextModule,
    ProgressSpinnerModule,
    ToastModule,
    TooltipModule,
    //CalendarModule,
    DatePickerModule,
    PickListModule,
    AccordionModule,
    BadgeModule,
    //ChipsModule,
    //InputSwitchModule,
    ToggleSwitchModule,
    PanelMenuModule,
    MultiSelectModule,
    SelectModule,
    //TabViewModule,
    TabsModule,
    RadioButtonModule,
    SkeletonModule,
    CarouselModule
  ],
schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
